import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Company } from '../models/company';
import { CompanyType } from '../models/companyType';
import { Plan } from '../models/plan';
import { environment } from 'src/environments/environment';


@Injectable()
export class RestaurantService {
    public url: string;

    constructor(
        private _http: HttpClient
    ) {
        this.url = environment.apiUrl;
    }

    // GET ONE ORDER
    getOrder(store, table, status): Promise<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + 'erprest-restaurantOrder/one/' + store + '/' + table + '/' + status, { headers: headers }).toPromise();
    }

    // GET ONE ORDER
    getAllOrder(store, status): Promise<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + 'erprest-restaurantOrder/' + store + '/' + status, { headers: headers }).toPromise();
    }

    // INSERT ORDER
    insertOrder(order): Promise<any> {
        let params = JSON.stringify(order);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post(this.url + 'erprest-restaurantOrder', params, { headers: headers }).toPromise();
    }

    updateOrder(order): Promise<any> {
        let params = JSON.stringify(order);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.put(this.url + 'erprest-restaurantOrder', params, { headers: headers }).toPromise();
    }



    /*

    // GET ALL COMPANY
    getAll(): Promise<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + 'erprest-company', { headers: headers }).toPromise();
    }

    // GET ONE COMPANY
    getOne(code): Promise<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + 'erprest-company/one/' + code, { headers: headers }).toPromise();
    }

    // GET ONE COMPANY
    getTables(storeCode): Promise<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + 'erprest-company/storeTables/' + storeCode, { headers: headers }).toPromise();
    }

    // GET ALL COMPANY TYPE
    getAllCompanyType(): Promise<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + 'erprest-companyType', { headers: headers }).toPromise();
    }

    // GET ALL COMPANY PLAN
    getAllCompanyPlan(): Promise<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + 'erprest-plan', { headers: headers }).toPromise();
    }

    // INSERT COMPANY
    insert(company: Company): Promise<any> {
        let params = JSON.stringify(company);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post(this.url + 'erprest-company', params, { headers: headers }).toPromise();
    }

    // INSERT COMPANY TYPE
    insertCompanyType(companyType: CompanyType): Promise<any> {
        let params = JSON.stringify(companyType);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post(this.url + 'erprest-companyType', params, { headers: headers }).toPromise();
    }

    // INSERT COMPANY PLAN
    insertCompanyPlan(plan: Plan): Promise<any> {
        let params = JSON.stringify(plan);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post(this.url + 'erprest-plan', params, { headers: headers }).toPromise();
    }

    // UPDATE COMPANY
    update(company: Company): Promise<any> {
        let params = JSON.stringify(company);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.put(this.url + 'erprest-company', params, { headers: headers }).toPromise();
    }

    // UPDATE COMPANY TYPE
    updateCompanyType(companyType: CompanyType): Promise<any> {
        let params = JSON.stringify(companyType);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.put(this.url + 'erprest-companyType', params, { headers: headers }).toPromise();
    }

    // UPDATE COMPANY PLAN
    updateCompanyPlan(plan: Plan): Promise<any> {
        let params = JSON.stringify(plan);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.put(this.url + 'erprest-plan', params, { headers: headers }).toPromise();
    }
    */
}